<template>
  <div class="error-notice__error">
    {{ isDevelopment ? error : this.$t('login.unknown-error') }}
  </div>
</template>

<script>
import { isDevelopment } from '@/config';

export default {
  name: 'ErrorNotice',
  props: {
    error: Error,
  },
  computed: {
    isDevelopment,
  },
};
</script>

<style lang="scss">
.error-notice {
  &__error {
    background-color: $color-error;
    border-radius: $border-radius-small;
    color: $color-neutral-pale;
    font-size: 16px;
    opacity: 1;
    margin-top: 25px;
    padding: 16px;
    position: relative;
    transition: opacity 200ms ease;
    visibility: visible;
  }
}
</style>
